import { render, staticRenderFns } from "./task-detail.vue?vue&type=template&id=33cd41bb&"
import script from "./task-detail.vue?vue&type=script&lang=ts&"
export * from "./task-detail.vue?vue&type=script&lang=ts&"
import style0 from "./task-detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports